import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;
export const Row = styled.div`
  display: flex;
  gap: ${spacing[2]};
`;
const control = `
  height: 2.25rem;
  border: 1px solid ${rawColors.grey[300]};
  border-radius: 0.375rem;
  padding: 0 ${spacing[2]};
  background: ${rawColors.structural.white};
  color: ${rawColors.text.highEmphasis};
`;
export const Amount = styled.input`
  ${control}
  width: 4.5rem;
`;
export const Until = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;
